export default "__VITE_ASSET__eQfmp8_m__"